import { render, staticRenderFns } from "./KurccQuestionPageActionBar.vue?vue&type=template&id=3aaa3b30&scoped=true&"
import script from "./KurccQuestionPageActionBar.vue?vue&type=script&lang=js&"
export * from "./KurccQuestionPageActionBar.vue?vue&type=script&lang=js&"
import style0 from "./KurccQuestionPageActionBar.vue?vue&type=style&index=0&id=3aaa3b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa3b30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VHover,VIcon,VRow})
